import { SvgIcon } from '@mui/material';
import React from 'react';

const SLOOrderIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <svg
        id="Calque_1"
        data-name="Calque 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 176.82 150"
        strokeWidth={0}
        fill="currentColor"
      >
        <g>
          <path d="m122.83,95.86v54.13H13.42V57.3h56.91c6.78,22.3,27.72,38.55,52.5,38.55Z" />
          <polygon points="65.54 52.19 13.42 52.19 29.15 31.74 65.54 31.74 65.54 52.19" />
        </g>
        <path d="m163.41,41.96c0,22.52-18.03,40.95-40.58,41.92-.61.03-1.24.04-1.87.04-17.94,0-33.3-11.04-39.5-26.62-.67-1.66-1.23-3.37-1.67-5.11-.84-3.28-1.28-6.71-1.28-10.23s.44-6.94,1.28-10.23C84.41,13.52,101.11,0,120.96,0c10.36,0,19.86,3.69,27.23,9.8l-5.87,5.8c-5.86-4.63-13.28-7.42-21.36-7.42-15.23,0-28.17,9.92-32.56,23.55-1.05,3.23-1.61,6.66-1.61,10.23s.56,7,1.61,10.23c.56,1.77,1.28,3.48,2.12,5.11,5.66,10.95,17.18,18.45,30.44,18.45.63,0,1.25-.01,1.87-.06,17.98-.96,32.32-15.72,32.32-33.74,0-3.7-.61-7.27-1.74-10.61l6.38-6.32c2.32,5.18,3.62,10.92,3.62,16.93Z" />
        <path d="m160.72,16.44l-41.01,40.86-1.14,1.14c-.9.9-1.94,1.48-3.18,1.45-1.25.01-2.27-.39-3.09-1.21l-6.57-6.49c-1.72-1.69-3.43-3.38-5.13-5.09-1.67-1.65-1.67-4.16-.09-5.8,1.67-1.76,4.19-1.94,5.97-.28,2.78,2.61,5.47,5.3,8.17,8,.56.55.83.48,1.34-.03l2.48-2.48,36.14-36.05c2.15-2.13,5.41-1.68,6.88.7,1.27,1.8.74,3.78-.77,5.27Z" />
      </svg>
    </SvgIcon>
  );
};

export default SLOOrderIcon;
